module.exports = __webpack_public_path__ + "static/tomatoes-abb5f59c70fefbdcb4cd9c856ac68809.jpg";